import { render, staticRenderFns } from "./OneSignalForm.vue?vue&type=template&id=24bdc30e"
import script from "./OneSignalForm.vue?vue&type=script&lang=js"
export * from "./OneSignalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports